import WbHttpClient from "./wbhttpclient";
import axios from 'axios';
import { withMirroredMetricStatus } from '../utils/okrFilterParams.util';

class GoalServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  async getKRExtract(params = {}) {
    return await this.WbHttpClient.get('goal/KRExtract', params);
  }

  async getTeamGoalData(qstrOrParams = '') {
    const request = withMirroredMetricStatus(qstrOrParams);
    if (typeof request === 'string') {
      return await this.WbHttpClient.get('goal/getTeamGoalData' + request);
    }
    return await this.WbHttpClient.get('goal/getTeamGoalData', request);
  }

  async getOkrDetails(qstr = '') {
    return await this.WbHttpClient.get('goal/getOkrDetails' + qstr);
  }

  async exportMicrosoftTemplateGoals(params = {}) {
    return await this.WbHttpClient.get('goal/exportMyGoals', params);
  }

  async getMyGoals(params = {}) {
    return await this.WbHttpClient.get("goal/getMyGoalsJson", params);
  }

  async getMyDependencyGoalsJson() {
    return await this.WbHttpClient.get("goal/getMyDependencyGoalsJson");
  }

  async getFilterDate(params = {}) {
    return await this.WbHttpClient.get("goal/okrFilterComp", params);
  }
  async categoryList(params = {}) {
    return await this.WbHttpClient.get("goal/getCategoryList", params);
  }

  showGoalMetricsComments(params = {}) {
    return this.WbHttpClient.get("goal/showGoalMetricsComments", params);
  }

  saveComment(params = {}) {
    return this.WbHttpClient.post("goal/saveGoalComment", params);
  }

  deleteComment(params = {}) {
    return this.WbHttpClient.post("goal/deleteGoalComment", params);
  }

  fireKRDetailsEvent() {
    return this.WbHttpClient.get("goal/fireKRDetailsEvent");
  }

  saveGoalOrder(params) {
    return this.WbHttpClient.post("goal/saveGoalOrder", params);
  }

  saveTeamGoalOrder(params) {
    const newParams = {
      teamId: params.id,
      goalIds: JSON.stringify(params.items)
    };
    return this.WbHttpClient.post("goal/saveTeamGoalOrder", newParams);
  }

  deleteMetricWishList(params) {
    return this.WbHttpClient.post("goal/deleteMetricWishList", params);
  }


  userMentionsData() {
    return this.WbHttpClient.get("goal/getUserMentionsData", {});
  }

  getGoalIndex() {
    return this.WbHttpClient.get("goal/index", { json: true });
  }

  getGoalData(params) {
    return this.WbHttpClient.get("goal/getGoalData", params);
  }

  pingMetric(params) {
    return this.WbHttpClient.post("goal/sendMetricPingNotification", params);
  }

  getDataStreamDetails(params) {
    return this.WbHttpClient.get("goal/getDsDetails", params);
  }


  getSearchKRresults(params = {}) {
    return this.WbHttpClient.get("goal/searchKRresults", params);
  }

  goalAlignmentSearch(params = {}) {
    return this.WbHttpClient.post("goal/goalAlignmentSearch?json", params);
  }

  getGoalAlignmentSearch(params = {}, cancel = null) {
    return this.WbHttpClient.get("goal/goalAlignmentSearch?json", params, cancel);
  }

  getFullAlignmentReport(params = {}) {
    return this.WbHttpClient.get("goal/getFullAlignmentReport?json", params);
  }

  goalAlignObjective(params = {}) {
    return this.WbHttpClient.get("goal/goalAlignObjective", params);
  }

  sendPublishEmail(url, params = {}) {
    return this.WbHttpClient.post(url, params);
  }

  addEditObjective(params = {}) {
    params.goal.created_from = 'Wizard';
    return this.WbHttpClient.post("goal/saveObjective", params);
  }

  addEditKr(params = {}) {
    params.metric.created_from = 'Wizard';
    return this.WbHttpClient.post("goal/saveKr", params).then((response) => {
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:keyResultUpdated');
        channel.postMessage(params.metric.id);
      }
      return response;
    });
  }

  saveGoalDetails(params = {}) {
    return this.WbHttpClient.get("goal/editGoalDetails", params);
  }

  editGoalDetails(params = {}) {
    return this.WbHttpClient.get("goal/editGoalDetails", params);
  }

  searchTeamName(params = {}) {
    return this.WbHttpClient.get("team/getUserManageTeamList", params);
  }

  searchPermTeamName(params = {}) {
    return this.WbHttpClient.get("team/getAllTeamsForThisOrg", params);
  }

  searchPermTeamsAndBiz(params = {}) {
    return this.WbHttpClient.get("team/getAllTeamsAndBiz?term", params);
  }

  getDefaultOkrPermittedTeam(params ={}) {
    return this.WbHttpClient.get("team/getDefaultOkrPermittedTeam", params);
  }

  getOwnerBySearch(params = {}) {
    return this.WbHttpClient.get("goal/getTeamMembers", params);
  }

  getOwnerNamebyTeamID(params = {}) {
    return this.WbHttpClient.get("team/getManagerCoManagerList", params);
  }

  getTeamNBizDetails(params = {}) {
    return this.WbHttpClient.get("team/getTeamNBizDetails", params);
  }


  editDescription(params = {}) {
    return this.WbHttpClient.post('goal/saveKrDesc', params);
  }

  searchObjectiveAlignment(params = {}) {
    return this.WbHttpClient.get("goal/SearchKrs", params);
  }

  searchObjectiveCategory(params = {}) {
    return this.WbHttpClient.get("goal/getGoalCategories", params);
  }

  searchWorkStream(params = {}) {
    return this.WbHttpClient.get("tag/getMyWs", params);
  }

  deleteObjective(params = {}) {
    return this.WbHttpClient.post("goal/deleteGoal", params).then((response) => {
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:objectiveDeleted');
        channel.postMessage(params.goalId);
      }
      return response;
    });
  }

  deleteMetric(params = {}) {
    return this.WbHttpClient.post("goal/deleteKr", params).then((response) => {
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:keyResultDeleted');
        channel.postMessage(params.metricId);
      }
      return response;
    });
  }

  createWorkstream(params = {}) {
    return this.WbHttpClient.post("tag/addWorksreamSubmit", params);
  }

  getDataStreamList(params = {}) {
    return this.WbHttpClient.post("goal/getDataStreamList", params);
  }

  authenticateExtApp(params = {}) {
    return this.WbHttpClient.post("integration/hello", params);
  }

  getQueryValidationforJira(params = {}, options = {}) {
    return this.WbHttpClient.post(
      "integration/queryExtProjects?app=jira",
      params,
      options
    );
  }

  getAllInstances(params = {}) {
    return this.WbHttpClient.get("integration/getAllInstances", params);
  }

  getExtProjects(params = {}) {
    return this.WbHttpClient.get("integration/queryExtProjects", params);
  }

  searchRollupOkrs(params = {}) {
    return this.WbHttpClient.get("goal/searchKrs", params);
  }

  updateGoalName(params = {}) {
    return this.WbHttpClient.post("goal/UpdateObjectiveName", params).then((response) => {
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:objectiveUpdated');
        channel.postMessage(response.data.id);
      }
      return response;
    });
  }

  saveMetricOrder(params = {}) {
    return this.WbHttpClient.post("goal/saveMetricOrder", params);
  }

  saveKRweightage(params = {}) {
    return this.WbHttpClient.post("goal/saveKRWeightage", params);
  }

  resetKrWeightingToDefaults(params = {}) {
    return this.WbHttpClient.post("goal/resetKrWeightingToDefaults", params);
  }

  createCascadeDetails(params) {
    return this.WbHttpClient.get("goal/createCascadeDetails", params);
  }

  getTeamAndOrgUsersList(params) {
    return this.WbHttpClient.get("goal/getTeamAndOrgUsersList", params);
  }

  deleteCascadeUserMetric(params = {}) {
    return this.WbHttpClient.post("goal/deleteCascadeUserMetric", params).then((response) => {
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:keyResultDeleted');
        channel.postMessage(params.metricId);
      }
      return response;
    });
  }

  closeCascadeMetric(params = {}) {
    return this.WbHttpClient.post("goal/closeCascadeMetric", params);
  }

  closeKeyResult(params = {}) {
    return this.WbHttpClient.post("goal/closeKeyResult", params);
  }

  reopenKeyResult(params = {}) {
    return this.WbHttpClient.post("goal/reopenKeyResult", params);
  }

  sendCascdePingNotification(params = {}) {
    return this.WbHttpClient.post("goal/sendCascdePingNotification", params);
  }

  updateMetricName(params = {}) {
    return this.WbHttpClient.post("goal/UpdateMetricName", params).then((response) => {
      const krId = params.metric_id;
      if (response.status === 200 && response.data) {
        const channel = new BroadcastChannel('okr:keyResultUpdated');
        channel.postMessage(krId);
      }
      return response;
    });
  }

  triggerGoalMetricDetails(params = {}) {
    return this.WbHttpClient.get("goal/getGoalMetrics", params);
  }

  editKr(params = {}) {
    return this.WbHttpClient.get("goal/getKrDetails", params);
  }

  saveMyOkrFilters(params = {}) {
    return this.WbHttpClient.post("goal/saveMyOkrFilters", params);
  }

  dueUpdates() {
    return this.WbHttpClient.get("people/dueUpdates");
  }

  saveOkrKrUpdateTooltip(params = {}){
    return this.WbHttpClient.post("goal/saveOkrKrUpdateTooltip", params);
  }

  orgEngagementFilterData(params = {}) {
    return this.WbHttpClient.post("workboard/orgEngagementFilterData", params);
  }

  convertOKR(params = {}) {
    return this.WbHttpClient.post("goal/convertOKR", params);
  }

  searchWorkStreamColumns(params = {}) {
    return this.WbHttpClient.get("tag/getWsColumns", params);
  }

  fetchAzureStates(params = {}) {
    return this.WbHttpClient.get("integration/getAzureProjectStates", params);
  }

  validateSelections(appName, type, params = {}) {
    switch (appName) {
      case "azure_cloud":
        switch (type) {
          case "id":
            return this.WbHttpClient.get(
              "integration/getAzureWorkItems",
              params
            );
          default:
            return false;
        }
      default:
        return false;
    }
  }

  fetchAndFilterAzureQueries(params = {}) {
    return this.WbHttpClient.get("integration/getAzureQueries", params);
  }

  fetchCommentList(params = {}) {
    return this.WbHttpClient.get('goal/getGoalComments', params);
  }

  getDataSource(params = {}) {
    return this.WbHttpClient.get('goal/dataSource', params);
  }
  getKrHeaders(params = {}) {
    return this.WbHttpClient.get('goal/krDetails', params)
  }

  searchMetricAlignment(params = {}) {
    return this.WbHttpClient.get('goal/searchKrs', params);
  }

  fetchGraphData(params = {}) {
    return this.WbHttpClient.get('goal/getKrGraphData', params);
  }

  fetchKrAttachments(params = {}) {
    return this.WbHttpClient.get('goal/getKrAttachments', params);
  }
  deleteKrAttachment(params = {}) {
    return this.WbHttpClient.post('goal/deleteKrAttachment', params);
  }

  saveKrLinkAttachments(params = {}) {
    return this.WbHttpClient.post('goal/saveKrpageAttachment', params)
  }

  getMentionUserList(params = {}) {
    return this.WbHttpClient.get('workboard/getRelatedMembers', params);
  }
  getviewCascadeTree(params = {}) {
    return this.WbHttpClient.get('goal/viewCascadeTree', params);
  }

  getAllMetricsByGoal(params = {}) {
    return this.WbHttpClient.get('goal/getAllMetricsByGoal', params);
  }

  getAllMetrics(params = {}) {
    return this.WbHttpClient.get('goal/GetMetricsForAlignment', params);
  }

  getKrAlignTreeData(params = {}) {
    return this.WbHttpClient.get('goal/getKrAlignTreeData', params);
  }

  firePushAnalyticsData(params = {}) {
    return this.WbHttpClient.get('workboard/pushAnalyticsFire', params);
  }

  getKrHoverData(params = {}) {
    return this.WbHttpClient.get('goal/sourcePopupDetails', params);

  }
  async getOrgResults(params = {}) {
    return await this.WbHttpClient.get("goal/orgResults", params);
  }

  getMyDirectsOKR(params = {}) {
    return this.WbHttpClient.get('goal/getMyDirectsOKR', params);
  }

  getTeamsOkr(params = {}) {
    return this.WbHttpClient.get('goal/teamgoal', withMirroredMetricStatus(params));
  }

  /**
   * No-op filter method for the heatmap page.
   * The heatmap reloads via ajaxPageLoad (full HTML), so no JSON API call
   * is needed. Resolves immediately so ObjectiveFilter.handleSubmit can
   * proceed to the updateOkrFilterVal callback (which triggers ajaxPageLoad).
   */
  heatmapNoOpFilter() {
    return Promise.resolve({ data: {} });
  }

  saveOkrExpandCollapse(params = {}) {
    return this.WbHttpClient.post("goal/saveOkrExpandCollapse", params);
  }

  getMyDirectsKR(params = {}) {
    return this.WbHttpClient.get("goal/getMyDirectsKR", params)
  }

  SaveShortcutBarPreference(params = {}) {
    return this.WbHttpClient.post("goal/SaveShortcutBarPreference", params);
  }

  closeOneTimeMessage(params = {}) {
    return this.WbHttpClient.post("goal/saveOKRAlignmentMessage", params);
  }

  getTeamsData(params = {}) {
    return this.WbHttpClient.get("goal/teamOKRAlignment", params)
  }

  getTeamOkrAlignment(params={}) {
    return this.WbHttpClient.get("goal/viewTeamOKRAlignment",params)
  }

  getPersonKrLists(params={}) {
    return this.WbHttpClient.get("goal/getPersonKrs",params)
  }

  triggerTrackEvent(params = {}) {
     return this.WbHttpClient.post("goal/trackEvent", params);
  }

  getPeopleJson(params = {}) {
    return this.WbHttpClient.get('goal/getPeopleJson', params);
  }

  getMetricCommentCount(params = {}) {
    return this.WbHttpClient.get('goal/getMetricCommentCount', params);
  }

  getMyUpdateKRs(params = {}, reqCallFrom ='updateMyKR') {
    let reqUrl = (reqCallFrom == 'updateKrs') ? 'goal/updateKrs' : 'goal/updateMyKR';
    return this.WbHttpClient.get(reqUrl, params);
  }

  saveUserKr(params = {}) {
    return this.WbHttpClient.post('goal/saveUserKr', params);
  }

  setConfidenceRating(params = {}) {
    return this.WbHttpClient.post('confidence/saveConfidence', params);
  }

  saveConfidenceComment(params = {}) {
    return this.WbHttpClient.post("confidence/editSaveConfidenceComment", params);
  }

  getClusterData(params = {}) {
    return this.WbHttpClient.get('goal/getKRClustering', params);
  }

  getClusterFireEvent(params = {}) {
    return this.WbHttpClient.get('goal/clusterFireEvent', params);
  }

  saveClosedGoal(params = {}) {
    return this.WbHttpClient.post('goal/saveClosedGoal', params);
  }

  getViewableMetricIds(params = {}) {
    return this.WbHttpClient.post('goal/getViewableMetricIds', params);
  }

  copyKrToOkr(params = {}) {
    return this.WbHttpClient.get('goal/copyKr', params);
  }

  getNLPTags(params) {
    return this.WbHttpClient.post("goal/getNlpTagLists", params);
  }
  getNlplTagsData(params) {
    return this.WbHttpClient.get('tag/getNlpKrTagLists',params);
  }
  viewMoreGoalNotification(params = {}) {
    return this.WbHttpClient.get("goal/getNotifications", params);
  }

  async patchKpiData(kpiDataId, payload, headerData) {
    let header = {
      headers: {
        Authorization: 'Bearer '+ headerData.access_token,
      }
    }

    return axios.patch(`${wbConfig.kpiUrl}/api/kpidata/${kpiDataId}`, payload, header);
  }

  async createKpiData(payload = {},headerData) {
    let header = {
      headers: {
        Authorization: 'Bearer '+ headerData.access_token,
      }
    }
    const response = await axios.post(`${wbConfig.kpiUrl}/api/kpidata`, payload,header);
    return response.data;
  }

  nlpOkrAlignment(params = {}) {
    return this.WbHttpClient.get('goal/nlpOkrAlignment', params);
  }


  krTagEvents(params = {}) {
    return this.WbHttpClient.get('tag/krTagEvents', params)
  }

  getAlignGoalMetrics(params = {}) {
    return this.WbHttpClient.get('goal/getAlignGoalMetrics', params);
  }

  nlpEventTrack(params = {}){
    return this.WbHttpClient.post('goal/trackNlpOkrAlignment', params);
  }

  getLongRangeStrategy(params = {}) {
    return this.WbHttpClient.get('goal/getLinkedStrategy', params);
  }

  /**
   * @param {string} searchStr
   * @returns Promise
   */
  searchPillars(searchStr = '') {
    return this.WbHttpClient.get('goal/searchPillars', { search: searchStr });
  }

  /**
   * @param {Array<number>} objectiveIds
   * @returns {Promise<{ data: { data: Record<string, Array<{ pillarId: string; name: string; canView: boolean; iconSvg: string; strategy: { id: string; canView: boolean; timeHorizon: string; startDate: string; endDate: string; name: string; }}>> } }>} Promise
   */
  getPillarsOnObjectives(objectiveIds = []) {
    return this.WbHttpClient.get('goal/getPillarsOnObjectives', { objectiveIds: objectiveIds?.map((id) => Number(id)) });
  }

  /**
   * @param {{ pillarIds: Array<string>, objectiveId: number }} params
   * @returns Promise
   */
  savePillarObjectiveAlignment(params = {}) {
    return this.WbHttpClient.post('goal/savePillarObjectiveAlignment', {
      pillarIds: params?.pillarIds?.map(String),
      objectiveId: params?.objectiveId && Number(params.objectiveId)
    });
  }

  /**
   * @param {{ pillarId: string, objectiveId: number }} params
   * @returns Promise
   */
  deletePillarObjectiveAlignment(params = {}) {
    return this.WbHttpClient.post('goal/deletePillarObjectiveAlignment', {
      pillarId: params?.pillarId && String(params.pillarId),
      objectiveId: params?.objectiveId && Number(params.objectiveId)
    });
  }

  strategyEventTracking(params = {}) {
    return this.WbHttpClient.get('goal/trackStrategyEvents', params);
  }

  getFileStatus(params = {}) {
    return this.WbHttpClient.get('fus/GetFileStatus', params)
  }

  krCalHoverEventTracking(params = {}) {
    return  this.WbHttpClient.get('goal/KrGraphEvents', params);
  }
  krAnnualDropdownEventTracking(params = {}) {
    return  this.WbHttpClient.post('goal/OkrAnnualQuarterEvents', params);
  }

  closeoutOKR (params = {}) {
    return this.WbHttpClient.get('workboard/closeOKR', params);
  }

  /**
   * @param {number} metricId
   * @param {number} [forceMetricUpdate=0] DO NOT set to 1. Only the manual Recalculate button in kr-header may pass 1.
   *   Passing 1 circumvents performance optimizations and will degrade OCE responsiveness. Do not "fix" stale data by flipping this.
   */
  recalculateMetric (metricId, forceMetricUpdate = 0) {
    return this.WbHttpClient.post('goal/recalculateMetric', { metricId, forceMetricUpdate });
  }

  logDataDog (message) {
    return this.WbHttpClient.post('goal/log', { message });
  }

  /**
   * Fetches custom fields configured for Objectives (OKR type)
   * Used for dynamic filter generation in objective filters
   *
   * @returns {Promise<AxiosResponse>} Response containing custom fields data
   *
   * Expected response shape:
   * {
   *   data: Array<{
   *     id: number,                    // Category ID
   *     name: string,                  // Category name
   *     customFields: Array<{
   *       id: number,                  // Custom field ID (used as fieldId in filter)
   *       name: string,                // Field label
   *       field_type_id: number,       // 1=Text, 2=TextArea, 3=Dropdown, 4=MultiSelect, 5=DatePicker
   *       object_type: number,         // 5=OKR, 6=KR
   *       is_required: string,         // '0' or '1'
   *       field_values?: Array<{       // Only for Dropdown (3) and MultiSelect (4)
   *         value: string,
   *         default_value: string
   *       }>
   *     }>
   *   }>
   * }
   */
  async getGoalCustomFields() {
    const { data } = await this.WbHttpClient.get('goal/GetGoalCustomFields');

    if (!Object.keys(data.data).length) {
      return [];
    }

    return Object.values(data.data)
      .map((category) =>
        Object.values(category.customFields).map((customField) => ({
          ...customField,
          categoryId: category.id,
          categoryName: category.name,
        })))
      .flat();
  }
}

export default GoalServices;
